import { Component, Input } from '@angular/core';
import { DatePipe } from "@angular/common";
import { Lookup } from '../../models/lookupmodel';
import { Acct } from '../../models/acctmodel';
import { AccountUpdate } from '../../models/accountupdatemodel';
import { Topup } from '../../models/topupmodel';
import { paymentService } from '../../services/payment.service';
import { SharedService } from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { Payment } from '../../models/paymentmodel';
import { PaymentResponse } from '../../models/responsemodel';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
//import { DataTableResource } from 'angular-2-data-table';

@Component({
  templateUrl: './payment.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [paymentService]
})

export class PaymentComponent {
  @Input() responseObj: Session;
  public paymentreq: Payment;
  public data;
  public acct: Acct;
  public acctupdate: AccountUpdate;
  public topup: Topup;
  public lookup;
  public smartcard: string;
  public subscribername: string;
  errorMessage: string;
  public itemResource;
  items = [];
  itemCount = 0;

  constructor(public _paymentService: paymentService, public router: Router, public sharedservice: SharedService) {

  }

  ngOnInit() {
    this.paymentreq = new Payment();
    this.lookup = JSON.parse(localStorage.getItem("lookup"));
    this.paymentreq.smartcard = localStorage.getItem("smartcard");
    this.paymentreq.basketid = this.getItem("BASKET_ID");
    this.paymentreq.firstname = this.getItem("FIRSTNAME");
    this.paymentreq.lastname = this.getItem("SURNAME");
    this.paymentreq.duedate = this.getItem("QUOTE_DUE_DATE");
    this.paymentreq.amount = this.getItem("PRIMARY_PRODUCT_PRICE_0");
    this.paymentreq.currentbouquet = this.getItem("PRIMARY_PRODUCT_DESC_0");
    this.paymentreq.merchantReference = this.sharedservice.newGuid();
    this.paymentreq.currency = this.getItem("PRIMARY_PRODUCT_CUREENCY_0");

  }

  accountLookup(isValid: boolean) {
    if (isValid) {
      this._paymentService.accountLookup(this.paymentreq).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
    }
  }

  handleResponse(result) {
    //console.log('response:' +  result);

  }

  getItem(itemName: string) {
    var itemValue = "";
    for (let index = 0; index < this.lookup['PayUVasResponse']['CustomFields'][0]['Customfield'].length; index++) {
      if (this.lookup['PayUVasResponse']['CustomFields'][0]['Customfield'][index]['$']['Key'] == itemName) {
        itemValue = this.lookup['PayUVasResponse']['CustomFields'][0]['Customfield'][index]['$']['Value'];
        break;
      }
    }
    return itemValue;
  }


}



// WEBPACK FOOTER //
// /tmp/build_713add00/src/app/payment/payment.component.ts